import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import useCrmObjectTypeListingFilters from './useCrmObjectTypeListingFilters';
import { useComputedFilters, useFiltersStateStore } from '../internal/providers/CrmObjectTypeListingClientProvider';
import useQuickFilters from './useQuickFilters';
export const useFilterGroups = () => {
  "use memo";

  return useComputedFilters().filterGroups;
};
export const useFilterQuery = () => {
  "use memo";

  return useFiltersStateStore(_temp);
};
export const useSortState = () => {
  "use memo";

  return useFiltersStateStore(_temp2);
};
export const useFiltersState = () => {
  "use memo";

  const $ = _c(4);
  const filterGroups = useFilterGroups();
  const quickFilters = useQuickFilters();
  const filterState = useFiltersStateStore(_temp3);
  let t0;
  if ($[0] !== filterGroups || $[1] !== filterState || $[2] !== quickFilters) {
    t0 = Object.assign({}, filterState, {
      filterGroups,
      quickFilters
    });
    $[0] = filterGroups;
    $[1] = filterState;
    $[2] = quickFilters;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export const useDeletedObjects = () => {
  "use memo";

  return useFiltersStateStore(_temp4);
};
export function useHiddenFilter() {
  "use memo";

  const $ = _c(2);
  const {
    hiddenFilter
  } = useCrmObjectTypeListingFilters();
  let t0;
  if ($[0] !== hiddenFilter) {
    t0 = hiddenFilter || {
      filterGroups: [{
        filters: []
      }]
    };
    $[0] = hiddenFilter;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(state) {
  return state.filtersState.query;
}
function _temp2(state) {
  return state.filtersState.sort;
}
function _temp3(state) {
  return state.filtersState;
}
function _temp4(state) {
  return state.deletedObjects;
}